import * as zod from 'zod';

import { TCPOffsetOptionStrict } from '@sb/motion-planning';

/**
 * Which tooltip a recorded path replays on: the frame it was recorded in, the
 * robot's Active Tooltip at run time, or one named outright.
 */
export const ReplayTooltip = zod.union([
  zod.object({ kind: zod.literal('saved') }),
  zod.object({ kind: zod.literal('active') }),
  zod.object({
    kind: zod.literal('explicit'),
    tcpOption: TCPOffsetOptionStrict,
    gripperID: zod.string().optional(),
  }),
]);

export type ReplayTooltip = zod.infer<typeof ReplayTooltip>;

/** What the editor writes onto a NEW step. */
export const DEFAULT_REPLAY_TOOLTIP: ReplayTooltip = { kind: 'saved' };
